// extracted by mini-css-extract-plugin
export var attachmentContainer = "_m8-0";
export var fileList = "_m8-2";
export var removeFileButton = "_m8-1";